import React from "react";
import { Row, Col, Card } from "@pankod/refine-antd";
import { TopProductsColumn } from "../charts/TopProductsColumn";
import { ProductClicksTable } from "../tables/ProductClicksTable";

interface ProductAnalysisTabProps {
  dateRange: [string, string];
  shopCode: string | null;
}

export const ProductAnalysisTab: React.FC<ProductAnalysisTabProps> = ({
  dateRange,
  shopCode,
}) => {
  return (
    <>
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <Card title="En Çok Tıklanan 20 Ürün">
            <TopProductsColumn
              dateRange={dateRange}
              shopCode={shopCode}
              limit={25}
            />
          </Card>
        </Col>
      </Row>
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24}>
          <ProductClicksTable dateRange={dateRange} shopCode={shopCode} />
        </Col>
      </Row>
    </>
  );
};
